import { SecurityConstants } from './../security/constants/security-constants';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutingService } from '../security/services/routing.service';
import { SecurityService } from '../security/services/security.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private securityService: SecurityService, private routingService: RoutingService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route && route.data && route.data.roles) {
      let expectedRoles: string[] = route.data.roles;
      if (expectedRoles.includes(SecurityConstants.ADMINISTRATOR_ROLE)) {
        return this.securityService
          .isAdministrator()
          .toPromise()
          .then(
            (isAdmin: boolean) => {
              return isAdmin;
            },
            (err) => {
              this.routingService.navigateToLoginPage();
              return false;
            }
          );
      } else if (expectedRoles.includes(SecurityConstants.CLIENT_ROLE)) {
        return this.securityService
          .isClient()
          .toPromise()
          .then(
            (isClient: boolean) => {
              return isClient;
            },
            (err) => {
              this.routingService.navigateToLoginPage();
              return false;
            }
          );
      } else if (expectedRoles.includes(SecurityConstants.USER_ROLE)) {
        return this.securityService
          .isUser()
          .toPromise()
          .then(
            (isUser: boolean) => {
              return isUser;
            },
            (err) => {
              this.routingService.navigateToLoginPage();
              return false;
            }
          );
      }
    }
    this.routingService.navigateToLoginPage();
    return false;
  }
}
